export const VER_ConversationWibContent = 1

export interface IConversationWibContent {
    description: string
    version: number
}